// // App.js
// import React from 'react';
// import { Routes, Route } from 'react-router-dom';
// import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { AppProvider } from './context/AppContext';
// import Layout from './components/common/Layout';
// import HomePage from './pages/HomePage';
// import ArticlePage from './pages/ArticlePage';
// import CategoryPage from './pages/CategoryPage';
// import SearchPage from './pages/SearchPage';
// import AboutPage from './pages/AboutPage';
// import ContactPage from './pages/ContactPage';
// import ErrorBoundary from './components/common/ErrorBoundary';
// import './styles/globals.css';

// const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: {
//       staleTime: 5 * 60 * 1000,
//       cacheTime: 10 * 60 * 1000,
//       retry: 1,
//       refetchOnWindowFocus: false,
//     },
//   },
// });

// function App() {
//   return (
//     <ErrorBoundary>
//       <QueryClientProvider client={queryClient}>
//         <AppProvider>
//           <Layout>
//             <Routes>
//               <Route path="/" element={<HomePage />} />
//               <Route path="/article/:slug" element={<ArticlePage />} />
//               <Route path="/category/:slug" element={<CategoryPage />} />
//               <Route path="/author/:slug" element={<CategoryPage />} />
//               <Route path="/search" element={<SearchPage />} />
//               <Route path="/about" element={<AboutPage />} />
//               <Route path="/contact" element={<ContactPage />} />
//               <Route path="*" element={
//                 <div className="min-h-screen flex items-center justify-center">
//                   <div className="text-center">
//                     <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
//                     <p className="text-gray-600 mb-8">Page non trouvée</p>
//                     <a href="/" className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700">
//                       Retour à l'accueil
//                     </a>
//                   </div>
//                 </div>
//               } />
//             </Routes>
//           </Layout>
//         </AppProvider>
//       </QueryClientProvider>
//     </ErrorBoundary>
//   );
// }

// export default App;

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppProvider } from './context/AppContext';

import Layout from './components/common/Layout';
import HomePage from './pages/HomePage';
import ArticlePage from './pages/ArticlePage';
import CategoryPage from './pages/CategoryPage';
import SearchPage from './pages/SearchPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ErrorBoundary from './components/common/ErrorBoundary';

import './styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AppProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/article/:slug" element={<ArticlePage />} />

              {/* ✅ Route pour catégories imbriquées */}
              <Route path="/category/:parentSlug/:childSlug" element={<CategoryPage />} />

              {/* ✅ Route pour catégories simples */}
              <Route path="/category/:slug" element={<CategoryPage />} />

              <Route path="/author/:slug" element={<CategoryPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />

              {/* Page 404 personnalisée */}
              <Route
                path="*"
                element={
                  <div className="min-h-screen flex items-center justify-center">
                    <div className="text-center">
                      <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
                      <p className="text-gray-600 mb-8">Page non trouvée</p>
                      <a
                        href="/"
                        className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700"
                      >
                        Retour à l'accueil
                      </a>
                    </div>
                  </div>
                }
              />
            </Routes>
          </Layout>
        </AppProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
